import { Typography } from "@mui/material";
import { SxProps, Theme } from '@mui/material/styles';
import {
  ArrayField,
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  DateField,
  List,
  NumberField,
  ReferenceField,
  TextField,
  TopToolbar,
} from 'react-admin';
import ListPagination from '../../../components/ListPagination';
import { DATE_FORMATER, PERMISSIONS } from '../../../constants';
import { Permission, ReferenceArrayFieldWithLimit } from "../../../components";
import CloneRuleButton from "../CloneRuleButton";

const listActionsSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  background: 'none',
  alignItems: 'center'
};

const warningSx: SxProps<Theme> = {
  '&::before': {
    content: "'* '",
    color: '#ff0000',
    fontSize: 20
  }
};

const BulkActionButtons = () => (
  <BulkDeleteButton label="Deletar" />
);

const ListActions = () => {
  return (
    <TopToolbar sx={listActionsSx}>
      <Typography sx={warningSx}>Recomendamos que essas informações estejam presentes no regulamento do programa de fidelidade do posto</Typography>
      <CreateButton />
    </TopToolbar>
  );
};

export default props => (
  <List
    title="Intervalo entre Abastecimentos"
    sort={{ field: 'createdAt', order: 'DESC' }}
    actions={<ListActions />}
    pagination={<ListPagination />}
    perPage={25}
    exporter={false}
    {...props}
  >
    <Datagrid rowClick="show" bulkActionButtons={<BulkActionButtons />}>
      <TextField source="identify" label="Código" />
      <ReferenceArrayFieldWithLimit
        source="stationIds"
        name="posto"
        label="Postos"
        reference="stations"
        link="show"
        permission={PERMISSIONS.LIST_STATION}
      />
      <NumberField label="Intervalo em Horas" source="interval" textAlign='center' />
      <ReferenceField
        label="Combustível"
        reference="fuels"
        source="fuelId"
        link={false}
        textAlign="center"
      >
        <TextField source="name" />
      </ReferenceField>
      <DateField
        source="createdAt"
        label="Data de Criação"
        options={DATE_FORMATER}
        sortable={false}
        textAlign='center'
        showTime
      />
      <Permission permission={PERMISSIONS.POINT_RULES}>
        <CloneRuleButton />
      </Permission>
    </Datagrid>
  </List>
);
